export const howtos = [
  {
    title: "How to Create your first Test Query",
    steps: [
      "On the left side of the Dashboard (homepage), Select The “Query Builder”",
      "Create a title for your query. For your first Test Query, let’s title it “CardioTest1”",
      "Next, note any related tags and/or descriptions for your query. For your first Test Query, we will be finding the number of patients that have a history of Acute Myocardial Infarction or an ICD 10 code of I21. You can note such in your description. Note: The Tags and Descriptions are not Mandatory but can be very helpful as a future reference to what was researched",
      "At the bottom of the page is where you can choose your desired Database to explore. The current options are IUSM Cardio and the IUSM Psych. For your first Test Query, we’ll be using the IUSM Cardio dataset",
      "After selecting the IUSM Cardio database click “Begin”",
      "You will now be on the “Query Builder” page. On the left side of the screen will see a vertical listing of search categories available to begin your search of the database. We will select “Diagnosis History”.",
      "Here we will see all the available diagnosis history as well as the ICD 10 Codes and type along with the Patient counts.",
      "In the search bar you will type in I21 in order to select all counts of I21 patients.",
      "Here we will see all the I21s accounts as well as the more specific related encounters such as I21.XX",
      "Since we want all cases of I21, you will click the “Select all” box. If you wanted to select specific cases, we could manually select them by clicking on the box next to the ICD description.",
      "Since we are searching for a specific ICD 10 code, change the select all type to “ICD Code” instead of “ICD Description”",
      "After selecting add, only the patient count will be updated and the rest of the data visualization data indicators on the top right of the page will be grayed out.",
      "If you want all data indicators updated, click the “Run Query” button at the top. Depending on the amount of filters and your total patient count, this may take some time for everything to be updated.",
      "You can modify the filter even more by clicking the subfilter icon in order to further filter a category. The sub-categories of the subfilter will depend on the category initially selected."
    ]
  },
  {
    title: "How to Download a Data File",
    steps: [
      "Ensure you have clicked on the “Run Query” button after you have selected your filters.",
      "Once the query has been completed, your data results will appear in the table at the bottom right of the screen.",
      "Click on the “Download File” button located above the data results table",
      "Select the data categories you would like to include in your download. (Data Elements)",
      "Click the “Download File” button after selecting the categories.",
      "Your browser will notify you when the download completes. You will receive a Zip File containing a CSV file per category"
    ]
  },
  {
    title: "How to send Feedback",
    steps: [
      "On the top right corner, click “Feedback”",
      "Select which type of Feedback (Bug, Enhancement, General)",
      "Give a General Description of the issue or recommendation",
      "It is highly recommended to submit a screenshot of your cohort to help the developers quickly identify the issue",
      "Click “Submit” when you are finished with the feedback"
    ]
  },
  {
    title: "How to use the AI Helper",
    steps: [
      "Click the “Support AI” on the bottom right corner.",
      "The AI can help you with any questions related to RWE DataLabs",
      "The AI specialized in:",
      {
        subList: [
          "Questions regarding RWE Data",
          "Questions regarding the Portal’s Functions",
          "Inclusions of related step by step guides",
          "Automated Feedback",
          "Finding specific ICD codes or CPT keys"
        ]
      }
    ]
  },
  {
    title: "How to Send Feedback using the AI Helper",
    steps: [
      "Click the AI helper in the bottom right corner",
      "State that you want to report a feedback",
      "Provide the necessary details or description of the feedback you'd like to send",
      "After submitting the information, ask the AI Helper to send the feedback"
    ]
  },
  {
    title: "How to Save a Query",
    steps: [
      "After creating a Query and Selecting your filters, anytime you select “Run Query” it will save your query under “Saved Queries”",
      "Under “Saved Queries” you are able to Open, Delete, and Duplicate your previously saved queries."
    ]
  },
  {
    title: "How to Share a Query",
    steps: [
      "Select The Query Builder",
      "When creating a Query, make sure the Box that states “Share this query anonymously with other users?” is Marked.",
      "This is marked by default",
      "This makes it where any queries you run will automatically share anonymously with other users"
    ]
  },
  {
    title: "How to Filter by Dates",
    steps: [
      "Select a Data Category such as Medication History",
      "After selecting a medication, use the subfilter to change the Start/Stop Date",
      "Use the format mm/dd/year",
      "Note: Data Categories such as Diagnosis History, Ejection Fraction, Lab Tests, Medication History, and Procedure History all contain a way to filter by a specific date."
    ]
  },
  {
    title: "How to use the Boolean Operators",
    steps: [
      "The Boolean operators are the “And” and “Or” modifiers next to your filter",
      "The “Or” is default and it will filter anything that you selected.",
      "The “And” will filter anything that you selected as long as it contains ALL the items in the same row.",
      "Using the example of searching for patients with Hypertension and Aneurysm",
      "Under Diagnosis History we would select ‘contains all’ for Hypertension",
      "If we would to modify Diagnosis History and add all Aneurysms, and change the “OR” to and “AND” then the result would be 0 patients",
      "The reason for this is that we are currently searching for a row that has both Hypertension and Aneurysm in its ICD Description. In order to have this query pull results, there needs to be a row that has the words Hypertension and Aneurysm in it.",
      "The way you would originally do this query would be by having two separate Diagnosis History. One contains Hypertension and the other contains Aneurysm."
    ]
  },
  {
    title: "How to Filter by Order of Events",
    steps: [
      "Select a Data Category such as Medication History",
      "After selecting a medication, use the sub-filter to change the Start Date",
      "Select another Data Category such as Diagnosis History",
      "After selecting a Diagnosis, use the sub-filter to change the date to be after/before the Previous date"
    ]
  },
  {
    title: "How to Filter by a negative",
    steps: [
      "Select a Data Category",
      "Search for a specific term, description, code, etc",
      "After adding a filter, change the “is” to and “is not”",
      "This can be applied to any filter"
    ]
  },
  {
    title: "How to search through unstructured data (Psych Only)",
    steps: [
      "The Data Categories Under “Clinical Notes” are considered Unstructured Data",
      "These Data Categories contain long texted-based Descriptions with no Code or ID to properly categorize, thus making it difficult to filter thoroughly",
      "Filtering under unstructured data will have a high chance of returning unrelated material as the data reflects the actual real-world data entered by practicing physicians and/or their authorized staff.",
      "It is currently recommended to use Structured Data to get your cohort as small as possible and download the file, so you can further examine the clinical notes personally."
    ]
  },
  {
    title: "How to Filter by Allergy Reaction",
    steps: [
      "Select Allergy History",
      "Search for an Allergy and Click “Add New Filter”",
      "Click the Sub-Filter button for Allergy History",
      "Search for the Reaction and Click “Save”"
    ]
  },
  {
    title: "How to Filter a Diagnosis into specific ICD Codes",
    steps: [
      "Search for a Diagnosis under Diagnosis History",
      "After Selecting a Diagnosis, Click the Sub-Filter button for Diagnosis History",
      "Scroll Down until you see ICD Code or Select ICD Code from the side menu",
      "Search for the ICD code you want to filter and Click “Save”"
    ]
  },
  {
    title: "How to Filter a Diagnosis into specific ICD Types",
    steps: [
      "Search for a Diagnosis under Diagnosis History",
      "After Selecting a Diagnosis, Click the Sub-Filter button for Diagnosis History",
      "Scroll Down until you see ICD Type or Select ICD Type from the side menu",
      "Select the ICD Type you want to filter and Click “Save”"
    ]
  },
  {
    title: "How to Filter an ICD Activity",
    steps: [
      "Search for a Diagnosis under Diagnosis History",
      "After Selecting a Diagnosis, Click the Sub-Filter button for Diagnosis History",
      "Scroll Down until you see ICD Active or Select ICD Active from the side menu",
      "Select the ICD activity you want and Click “Save”"
    ]
  },
  {
    title: "How to Search for ICD Ranges",
    steps: [
      "Select Diagnosis History",
      "In the search bar, type I22-I24",
      "Change ICD Description to ICD Code and select all.",
      "Click add new Filter.",
      "It is very important to note that this will select all ICD codes that start with I22 and I23, but only include I24. Others such as I24.1 will not be included.",
      "If we wanted to include all of I24, we would change our original range to be I22-I24.99",
      "Note: This applies the same way for CPT keys under Procedure History"
    ]
  },
  {
    title: "How to Filter by Diagnosis Date",
    steps: [
      "Search for a Diagnosis under Diagnosis History",
      "After Selecting a Diagnosis, Click the Sub-Filter button for Diagnosis History",
      "Scroll Down until you see Diagnosis Date or Select Diagnosis Date from the side menu",
      "Add a date in the format of mm/dd/yyyy and select its modifier.",
      "Click “Save”"
    ]
  },
  {
    title: "Searching by Ejection Fraction",
    steps: [
      "How to change the minimum and maximum Ejection Fraction Values",
      "Search and Select an Ejection Fraction Procedure under “Ejection Fraction:",
      "Click the Sub-Filter button for the Ejection Fraction",
      "Change the default values and modifiers of “EF Value Min” and “EF Value Max”",
      "Click “Save”"
    ]
  },
  {
    title: "How to change the Ejection Fraction’s Studied Date",
    steps: [
      "Search and Select an Ejection Fraction Procedure under “Ejection Fraction:",
      "Click the Sub-Filter button for the Ejection Fraction",
      "Under “Study Date”, add a date in the format of mm/dd/yyyy and select its modifier.",
      "Click “Save”"
    ]
  },
  {
    title: "How to Filter by Lab Ranges",
    steps: [
      "Search and Select a Lab Test under “Lab Test”",
      "Select the corresponding Sub-filter for “Lab Test”",
      "Select “Reference Ranges” on the left menu or scroll down until you see “Reference Range”",
      "Search for a range you want to Filter from and click “Save”"
    ]
  },
  {
    title: "How to change the Unit of Measure used in Lab Test",
    steps: [
      "Search and Select a Lab Test under “Lab Test”",
      "Select the corresponding Sub-filter for “Lab Test”",
      "Under “Unit of Measure” search for the item you want to filter.",
      "Click “Save”"
    ]
  },
  {
    title: "How to obtain results from Lab Test",
    steps: [
      "Select a desired Lab Test",
      "Click the Sub-filter Button",
      "Select a Reference Range",
      "Then select a Lab Value"
    ]
  },
  {
    title: "How can I obtain the findings from lab tests that yield multiple results such as CBC or METABOLIC PANEL?",
    steps: [
      "Lab Tests like CBC or METABOLIC PANEL encompass various results. To pinpoint a particular CBC or METABOLIC PANEL result, one must search using the corresponding LOINC code linked to the test.",
      "Using the Example of CBC, to obtain the Erythrocytes or Red Blood Cell Count results, rather than searching for CBC, you'd search using the associated LOINC Code for Red Blood Cell count, which is 789-8.",
      "Under Lab Tests, Search for 789-8 and change the search type to “LOINC Test Code”",
      "Select the corresponding result that you want and add your filter."
    ]
  },
  {
    title: "How to connect Lab Tests to LOINC test code?",
    steps: [
      "It may be difficult to associate a Lab Test to a specific LOINC code when searching using a Description",
      `If you search for "Basic metabolic panel" and select all, this action will encompass all lab tests linked to the "Basic metabolic panel" which could potentially distort the results. Note: It is recommended to search using Codes rather than Descriptions. For this case searching a specific LOINC code would produce more accurate results.`,
      "In order to Link the Lab test to a specific Lonic code. You first add your filter, and select “Download File”, and then “Lab Test”",
      "After the file downloads, it may take a minute depending on the size, open the file with excel and find the Column “LOINC_TEST_CODE” and “TEST_NAME”",
      "Using these two columns, you can identify what specific part of the lab test each result corresponds to.",
      "For examples, with the “LOINC_TEST_CODE” being 7898 and the “TEST_NAME” being CBC WITH DIFFERENTIAL/PLATELET we know that the patient’s observation value is being associated with the Erythrocytes or Red Blood Cell Count, since 7898 is the LOINC Code for a Erythrocytes count.",
      "Note: If you want to search for a LOINC Code use the following Link: https://loinc.org/ This Link will show you the LOINC Codes and its corresponding Lab Test"
    ]
  },
  {
    title: "How to search for Generic and Brand Medication",
    steps: [
      "Select Medication History",
      "Search for a Generic or Brand Medication.",
      "To include both Generic and Brand Medication, search for each separately by using the “Modify Filter” button and then click “Add to Existing”",
      "Make sure that the Boolean Operator next to Medication History is an “or” and not an “and”"
    ]
  },
  {
    title: "How to search for patients on multiple medications",
    steps: [
      "Click Medication History and Select your Medication",
      "Click “Modify Filter”",
      "Select your next medication, and then click “Add to Existing”",
      "Note: It is important to make sure that the boolean operator is set to “or”"
    ]
  },
  {
    title: "How to Filter by Medication Strength",
    steps: [
      "Select “Medication History”",
      "Search and select a specific Medication",
      "After creating the filter, use the sub-filter button",
      "Select “Medication Strength” on the left side of the screen.",
      "Select the desired Dosage amount and click save."
    ]
  },
  {
    title: "How to Filter by Medication Specialty",
    steps: [
      "Select “Medication History”",
      "Search and select a specific Medication",
      "After creating the filter, use the sub-filter button",
      "Search for your desired Specialty under “Specialty”",
      "Click “Save”."
    ]
  },
  {
    title: "How to Filter by Medication Form",
    steps: [
      "Select “Medication History”",
      "Search and select a specific Medication",
      "After creating the filter, use the sub-filter button",
      "Select “Form” on the left side of the screen or scroll down until you see “Form”.",
      "Select the desired Medication Form and click “Save”."
    ]
  },
  {
    title: "How to Filter by Medication’s Route of Administration",
    steps: [
      "Select “Medication History”",
      "Search and select a specific Medication",
      "After creating the filter, use the sub-filter button",
      "Select “Route of Administration” on the left side of the screen or scroll down until you see “Route of Administration”.",
      "Select the desired Medication Administration and click “Save”."
    ]
  },
  {
    title: "How to Filter by Medication’s Activity",
    steps: [
      "Select “Medication History”",
      "Search and select a specific Medication",
      "After creating the filter, use the sub-filter button",
      "Select “Not Active” on the left side of the screen or scroll down until you see “Not Active”.",
      "Select the desired Medication Activity and click “Save”."
    ]
  },
  {
    title: "How to Filter by Medication Start and Stop Date",
    steps: [
      "Select “Medication History”",
      "Search and select a specific Medication",
      "After creating the filter, use the sub-filter button",
      "Select “Start Date” or “Stop Date” on the left side of the screen or scroll down until you see “Stop Date”.",
      "Add a date in the format of mm/dd/yyyy and select its modifier.",
      "Click “Save”"
    ]
  },
  {
    title: "How to Filter by Male/Female/Other",
    steps: [
      "Select “Patient Demographics”",
      "Select Male, Female, or Not Specified",
      "If you want to include all, Click the “Select all Patient Demographic” box on the top",
      "Click “Add New Filter”"
    ]
  },
  {
    title: "How to Filter by Age",
    steps: [
      "Under Patient Demographics, Select either Male/Female/Not Specified or All",
      "Click the subfilter",
      "Birth Year and Age will be on the top.",
      "For Birth Year, enter a start and end year (e.g., 1984 to 1992) using the year range fields. The filter defaults to \"between\" for selecting a range of years.",
      "For Age, enter a numeric value and select a modifier (e.g., greater than, less than, between).",
      "Click \"Save\"",
      "Note: Patients aged 4 or younger have a null birth year and will be excluded from birth year filter results. For patients older than 84, the birth year is capped at the current year minus 84."
    ]
  },
  {
    title: "How to Filter by Birth Year",
    steps: [
      "Under Patient Demographics, Select either Male/Female/Not Specified or All",
      "Click the Sub-filter button",
      "The Birth Year section is at the top of the sub-filters panel",
      "The default operator is \"between\" which allows you to specify a year range. Enter a start year and end year (e.g., 1984 and 1992) to include all patients born within that range, inclusive.",
      "You can also change the operator to filter differently:",
      {
        subList: [
          "\"less than\" - patients born before a specific year",
          "\"greater than\" - patients born after a specific year",
          "\"less than or equal to\" - patients born on or before a specific year",
          "\"greater than or equal to\" - patients born on or after a specific year",
          "\"between\" - patients born within a range of years"
        ]
      },
      "Click \"Save\" to apply the birth year filter",
      { text: "Note: Patients aged 4 or younger have a null birth year and will be excluded from results. For patients older than 84, the birth year is capped at the current year minus 84.", link: { label: "See more", href: "/faq#birth-year-faq" } }
    ]
  },
  {
    title: "How to Filter by Marital Status",
    steps: [
      "Under Patient Demographics, Select either Male/Female/Not Specified or All",
      "Click the Sub-filter",
      "Under Marital Status, select your desired status",
      "Click “Save”"
    ]
  },
  {
    title: "How to Filter by Locations (State or ADI Score)",
    steps: [
      "Under Patient Demographics, Select either Male/Female or All",
      "Click the sub-filter",
      "Select “State” or “ADI Score” on the left menu or scroll to the bottom until you see “State” or “ADI Score”",
      "Select which State or ADI Score you want to filter",
      "Click “Save”"
    ]
  },
  {
    title: "How to Filter by Race",
    steps: [
      "Under Patient Demographics, Select either Male/Female/Not Specified or All",
      "Click the Sub-filter",
      "Select “Race” on the left side or scroll down until you see “Race”",
      "Filter a Race and Click “Save”"
    ]
  },
  {
    title: "How to Filter a range of CPT key",
    steps: [
      "Select Procedure History",
      "In the search bar, type 0295T-0298T",
      "Make sure to use CPT Key and not CPT Description",
      "Click the “Select all“ button",
      "Click add new Filter."
    ]
  },
  {
    title: "How to Filter by Procedure Date",
    steps: [
      "Select a Procedure under “Procedure History”",
      "Click the associated Sub-filter button",
      "Under “Procedure Date”, Add a date in the format of mm/dd/yyyy and select its modifier.",
      "Click “Save”",
    ]
  },
  {
    title: "How to use Vital Sign History effectively",
    steps: [
      "Select Vital Sign History and pick a Filter",
      "The Vital Sign History Data Element revolves around its Sub-filter as it needs to have a value associated with it",
      "Select the subfilter and assign a value",
      "Click “Save”",
    ]
  }
]